import { useEffect, useRef, useState } from "react";
function usePolling(pollFn, pollingIntervalMs) {
    useEffect(()=>{
        if (void 0 === pollingIntervalMs) return;
        const timer = setInterval(pollFn, pollingIntervalMs);
        return ()=>{
            clearInterval(timer);
        };
    }, [
        pollFn,
        pollingIntervalMs
    ]);
}
function useRetryWithBackoff(retryFn, loading, error) {
    const errors = useRef({
        count: 0
    });
    if (void 0 === error) errors.current = {
        count: 0,
        lastCounted: void 0
    };
    else if (error !== errors.current.lastCounted) errors.current = {
        count: errors.current.count + 1,
        lastCounted: error
    };
    let retrySeconds;
    if (false === loading) retrySeconds = getRetrySeconds(errors.current.count);
    useEffect(()=>{
        if (void 0 === retrySeconds) return;
        const timer = setTimeout(retryFn, 1000 * retrySeconds);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        retrySeconds,
        retryFn
    ]);
    return retrySeconds;
}
const RETRY_SECONDS = [
    5,
    10,
    30,
    90,
    180
];
function getRetrySeconds(errorCount) {
    if (errorCount <= 0) return;
    const retryIndex = errorCount - 1;
    return retryIndex < RETRY_SECONDS.length - 1 ? RETRY_SECONDS[retryIndex] : RETRY_SECONDS[RETRY_SECONDS.length - 1];
}
function useCountdown(seconds) {
    const timerSeconds = useRef(void 0);
    const [timerSecondsLeft, setTimerSecondsLeft] = useState(0);
    useEffect(()=>{
        if (void 0 === seconds) return;
        timerSeconds.current = seconds;
        setTimerSecondsLeft(seconds);
        const timer = setInterval(()=>{
            setTimerSecondsLeft((current)=>{
                const next = current - 1;
                if (next <= 0) clearInterval(timer);
                return next;
            });
        }, 1000);
        return ()=>{
            timerSeconds.current = void 0;
            setTimerSecondsLeft(0);
            clearInterval(timer);
        };
    }, [
        seconds
    ]);
    if (timerSeconds.current === seconds) return timerSecondsLeft;
    return seconds ?? 0;
}
export { useCountdown, usePolling, useRetryWithBackoff };

//# sourceMappingURL=timers.js.map